import { DARK_MODE } from "./dark-mode";

export const Bitbucket = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <g clipPath="url(#clip0_505_1607)">
      <g clipPath="url(#clip1_505_1607)">
        <path
          d="M0.575299 0.87666C0.501037 0.8757 0.427465 0.891009 0.359751 0.921512C0.292036 0.952016 0.231821 0.996974 0.183333 1.05323C0.134846 1.10949 0.099262 1.17567 0.0790809 1.24715C0.0588998 1.31862 0.0546107 1.39365 0.066515 1.46695L2.2264 14.5788C2.2533 14.7392 2.33588 14.8851 2.45964 14.9907C2.58339 15.0963 2.74041 15.1549 2.9031 15.1563H13.2649C13.3868 15.1578 13.5053 15.1155 13.5986 15.0371C13.692 14.9586 13.7541 14.8493 13.7736 14.7289L15.9335 1.4695C15.9454 1.39619 15.9411 1.32118 15.9209 1.24971C15.9007 1.17825 15.8651 1.11208 15.8166 1.05583C15.7681 0.999591 15.7079 0.954646 15.6402 0.924154C15.5725 0.893661 15.4989 0.878361 15.4247 0.879327L0.575299 0.87666ZM9.67013 10.3531H6.36292L5.46743 5.67469H10.4715L9.67013 10.3531Z"
          fill="#2684FF"
        />
        <path
          d="M15.2335 5.66811H10.4623L9.66148 10.3428H6.35693L2.45502 14.9743C2.57869 15.0812 2.73636 15.1407 2.89985 15.142H13.2559C13.3778 15.1436 13.4961 15.1013 13.5894 15.023C13.6828 14.9446 13.7448 14.8353 13.7643 14.715L15.2335 5.66811Z"
          fill="url(#paint0_linear_505_1607)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_505_1607"
        x1="16.3366"
        y1="6.97722"
        x2="10.8251"
        y2="14.803"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.18" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
      <clipPath id="clip0_505_1607">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_505_1607">
        <rect
          width="16"
          height="14.4384"
          fill="white"
          transform="translate(0 0.780792)"
        />
      </clipPath>
    </defs>
  </svg>
);
